module.exports = __webpack_public_path__ + "static/media/winZoleAll_1.66718b3e.png";